import { GLOBAL_TYPES } from '../reducers/types';
import { createAction } from './common';

export const clearStore = createAction(
  GLOBAL_TYPES.CLEAR_ALL_INFO_FROM_REDUCER
);
